var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91622 15.5979C10.0748 15.5979 11.0141 14.6587 11.0141 13.5001C11.0141 12.3415 10.0748 11.4022 8.91622 11.4022C7.7576 11.4022 6.81836 12.3415 6.81836 13.5001C6.81836 14.6587 7.7576 15.5979 8.91622 15.5979Z",
    fill: "#18202F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.258 15.5979C17.4166 15.5979 18.3559 14.6587 18.3559 13.5001C18.3559 12.3415 17.4166 11.4022 16.258 11.4022C15.0994 11.4022 14.1602 12.3415 14.1602 13.5001C14.1602 14.6587 15.0994 15.5979 16.258 15.5979Z",
    fill: "#18202F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91622 8.25535C10.0748 8.25535 11.0141 7.31611 11.0141 6.15749C11.0141 4.99887 10.0748 4.05963 8.91622 4.05963C7.7576 4.05963 6.81836 4.99887 6.81836 6.15749C6.81836 7.31611 7.7576 8.25535 8.91622 8.25535Z",
    fill: "#18202F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.258 8.25541C17.4166 8.25541 18.3559 7.31617 18.3559 6.15755C18.3559 4.99894 17.4166 4.05969 16.258 4.05969C15.0994 4.05969 14.1602 4.99894 14.1602 6.15755C14.1602 7.31617 15.0994 8.25541 16.258 8.25541Z",
    fill: "#18202F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91622 22.9404C10.0748 22.9404 11.0141 22.0012 11.0141 20.8425C11.0141 19.6839 10.0748 18.7447 8.91622 18.7447C7.7576 18.7447 6.81836 19.6839 6.81836 20.8425C6.81836 22.0012 7.7576 22.9404 8.91622 22.9404Z",
    fill: "#18202F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.258 22.9404C17.4166 22.9404 18.3559 22.0012 18.3559 20.8425C18.3559 19.6839 17.4166 18.7447 16.258 18.7447C15.0994 18.7447 14.1602 19.6839 14.1602 20.8425C14.1602 22.0012 15.0994 22.9404 16.258 22.9404Z",
    fill: "#18202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.3c0afc89fae9b0a85839800d2bf1e94b.svg";
export { ForwardRef as ReactComponent };